/* import __COLOCATED_TEMPLATE__ from './signal-config-area.hbs'; */
import Component from '@ember/component';
import { computed } from '@ember/object';

////////////////////////////////////////////////////////////////////////////////////
// signal-config-area - Component that contains the textboxes that contain the    //
// minimum and maximum values of the common mode and differential voltages        //
////////////////////////////////////////////////////////////////////////////////////

export default class SignalConfigArea extends Component {
  tagName = '';

  ////////////////////////////////////////////////////////////////////////////////
  // Computed Values                                                            //
  ////////////////////////////////////////////////////////////////////////////////

  @computed('validationResults.{isAllValid,isOperatingRange}') get showError() {
    let isAllValid = this.validationResults.isAllValid;
    let isOperatingRange = this.validationResults.isOperatingRange;
    return !isAllValid || !isOperatingRange;
  }
}
